// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("leaflet.routing.icons.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("routing-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-routing-container, .leaflet-routing-error {
    width: 320px;
    background-color: white;
    padding-top: 4px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.leaflet-control-container .leaflet-routing-container-hide {
    width: 32px;
    height: 32px;
}

.leaflet-routing-container h2 {
    font-size: 14px;
}

.leaflet-routing-container h3 {
    font-size: 12px;
    font-weight: normal;
}

.leaflet-routing-collapsible .leaflet-routing-geocoders {
    margin-top: 20px;
}

.leaflet-routing-alt, .leaflet-routing-geocoders, .leaflet-routing-error {
    padding: 6px;
    margin-top: 2px;
    margin-bottom: 6px;
    border-bottom: 1px solid #ccc;
    max-height: 320px;
    overflow-y: auto;
    transition: all 0.2s ease;
}

.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-alt, 
.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-geocoders {
    display: none;
}

.leaflet-bar .leaflet-routing-alt:last-child {
    border-bottom: none;
}

.leaflet-routing-alt-minimized {
    color: #888;
    max-height: 64px;
    overflow: hidden;
    cursor: pointer;
}

.leaflet-routing-alt table {
    border-collapse: collapse;
}

.leaflet-routing-alt tr:hover {
    background-color: #eee;
    cursor: pointer;
}

.leaflet-routing-alt::-webkit-scrollbar {
    width: 8px;
}

.leaflet-routing-alt::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #eee;
}

.leaflet-routing-alt::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #888;
}

.leaflet-routing-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    -webkit-background-size: 240px 20px;
    background-size: 240px 20px;
    background-repeat: no-repeat;
    margin: 0;
    content: '';
    display: inline-block;
    vertical-align: top;
    width: 20px;
    height: 20px;
}

.leaflet-routing-icon-continue         { background-position: 0 0; }
.leaflet-routing-icon-sharp-right      { background-position: -20px 0; }
.leaflet-routing-icon-turn-right       { background-position: -40px 0; }
.leaflet-routing-icon-bear-right       { background-position: -60px 0; }
.leaflet-routing-icon-u-turn           { background-position: -80px 0; }
.leaflet-routing-icon-sharp-left       { background-position: -100px 0; }
.leaflet-routing-icon-turn-left        { background-position: -120px 0; }
.leaflet-routing-icon-bear-left        { background-position: -140px 0; }
.leaflet-routing-icon-depart           { background-position: -160px 0; }
.leaflet-routing-icon-enter-roundabout { background-position: -180px 0; }
.leaflet-routing-icon-arrive           { background-position: -200px 0; }
.leaflet-routing-icon-via              { background-position: -220px 0; }

.leaflet-routing-geocoders div {
    padding: 4px 0px 4px 0px;
}

.leaflet-routing-geocoders input {
    width: 303px;
    width: calc(100% - 4px);
    line-height: 1.67;
    border: 1px solid #ccc;
}

.leaflet-routing-geocoders button {
    font: bold 18px 'Lucida Console', Monaco, monospace;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    margin: 0;
    margin-right: 3px;
    float: right;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.leaflet-routing-add-waypoint:after {
    content: '+';
}

.leaflet-routing-reverse-waypoints:after {
    font-weight: normal;
    content: '\\21c5';
}

.leaflet-routing-geocoders button:hover {
    background-color: #eee;
}

.leaflet-routing-geocoders input,.leaflet-routing-remove-waypoint,.leaflet-routing-geocoder {
    position: relative;
}

.leaflet-routing-geocoder-result {
    font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
    position: absolute;
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s ease;
    z-index: 1000; /* Arbitrary, but try to be above "most" things. */
}

.leaflet-routing-geocoder-result table {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    background-color: white;
    cursor: pointer;
}

.leaflet-routing-geocoder-result-open {
    max-height: 800px;
}

.leaflet-routing-geocoder-selected, .leaflet-routing-geocoder-result tr:hover {
    background-color: #eee;
}

.leaflet-routing-geocoder-no-results {
    font-style: italic;
    color: #888;
}

.leaflet-routing-remove-waypoint {
    background-color: transparent;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.leaflet-routing-remove-waypoint:after {
    position: absolute;
    display: block;
    width: 15px;
    height: 1px;
    z-index: 1;
    right: 1px;
    top: 4px;
    bottom: 0;
    margin: auto;
    padding: 2px;
    font-size: 18px;
    font-weight: bold;
    content: "\\00d7";
    text-align: center;
    cursor: pointer;
    color: #ccc;
    background: white;
    padding-bottom: 16px;
    margin-top: -16px;
    padding-right: 4px;
    line-height: 1;
}

.leaflet-routing-remove-waypoint:hover {
    color: black;
}

.leaflet-routing-instruction-distance {
    width: 48px;
}

.leaflet-routing-collapse-btn {
    position: absolute;
    top: 0;
    right: 6px;
    font-size: 24px;
    color: #ccc;
    font-weight: bold;
}

.leaflet-routing-collapse-btn:after {
    content: '\\00d7';
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn {
    position: relative;
    left: 4px;
    top: 4px;
    display: block;
    width: 26px;
    height: 23px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn:after {
    content: none;
}

.leaflet-top .leaflet-routing-container.leaflet-routing-container-hide {
    margin-top: 10px !important;
}
.leaflet-right .leaflet-routing-container.leaflet-routing-container-hide {
    margin-right: 10px !important;
}
.leaflet-bottom .leaflet-routing-container.leaflet-routing-container-hide {
    margin-bottom: 10px !important;
}
.leaflet-left .leaflet-routing-container.leaflet-routing-container-hide {
    margin-left: 10px !important;
}

@media only screen and (max-width: 640px) {
    .leaflet-routing-container {
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yDAAkD;IAClD,mCAAmC;IACnC,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA,yCAAyC,wBAAwB,EAAE;AACnE,yCAAyC,4BAA4B,EAAE;AACvE,yCAAyC,4BAA4B,EAAE;AACvE,yCAAyC,4BAA4B,EAAE;AACvE,yCAAyC,4BAA4B,EAAE;AACvE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,6BAA6B,EAAE;;AAExE;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mDAAmD;IACnD,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,aAAa,EAAE,kDAAkD;AACrE;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,UAAU;IACV,UAAU;IACV,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yDAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,oBAAoB;QACpB,qBAAqB;QACrB,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".leaflet-routing-container, .leaflet-routing-error {\n    width: 320px;\n    background-color: white;\n    padding-top: 4px;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n}\n\n.leaflet-control-container .leaflet-routing-container-hide {\n    width: 32px;\n    height: 32px;\n}\n\n.leaflet-routing-container h2 {\n    font-size: 14px;\n}\n\n.leaflet-routing-container h3 {\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.leaflet-routing-collapsible .leaflet-routing-geocoders {\n    margin-top: 20px;\n}\n\n.leaflet-routing-alt, .leaflet-routing-geocoders, .leaflet-routing-error {\n    padding: 6px;\n    margin-top: 2px;\n    margin-bottom: 6px;\n    border-bottom: 1px solid #ccc;\n    max-height: 320px;\n    overflow-y: auto;\n    transition: all 0.2s ease;\n}\n\n.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-alt, \n.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-geocoders {\n    display: none;\n}\n\n.leaflet-bar .leaflet-routing-alt:last-child {\n    border-bottom: none;\n}\n\n.leaflet-routing-alt-minimized {\n    color: #888;\n    max-height: 64px;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.leaflet-routing-alt table {\n    border-collapse: collapse;\n}\n\n.leaflet-routing-alt tr:hover {\n    background-color: #eee;\n    cursor: pointer;\n}\n\n.leaflet-routing-alt::-webkit-scrollbar {\n    width: 8px;\n}\n\n.leaflet-routing-alt::-webkit-scrollbar-track {\n    border-radius: 2px;\n    background-color: #eee;\n}\n\n.leaflet-routing-alt::-webkit-scrollbar-thumb {\n    border-radius: 2px;\n    background-color: #888;\n}\n\n.leaflet-routing-icon {\n    background-image: url('leaflet.routing.icons.png');\n    -webkit-background-size: 240px 20px;\n    background-size: 240px 20px;\n    background-repeat: no-repeat;\n    margin: 0;\n    content: '';\n    display: inline-block;\n    vertical-align: top;\n    width: 20px;\n    height: 20px;\n}\n\n.leaflet-routing-icon-continue         { background-position: 0 0; }\n.leaflet-routing-icon-sharp-right      { background-position: -20px 0; }\n.leaflet-routing-icon-turn-right       { background-position: -40px 0; }\n.leaflet-routing-icon-bear-right       { background-position: -60px 0; }\n.leaflet-routing-icon-u-turn           { background-position: -80px 0; }\n.leaflet-routing-icon-sharp-left       { background-position: -100px 0; }\n.leaflet-routing-icon-turn-left        { background-position: -120px 0; }\n.leaflet-routing-icon-bear-left        { background-position: -140px 0; }\n.leaflet-routing-icon-depart           { background-position: -160px 0; }\n.leaflet-routing-icon-enter-roundabout { background-position: -180px 0; }\n.leaflet-routing-icon-arrive           { background-position: -200px 0; }\n.leaflet-routing-icon-via              { background-position: -220px 0; }\n\n.leaflet-routing-geocoders div {\n    padding: 4px 0px 4px 0px;\n}\n\n.leaflet-routing-geocoders input {\n    width: 303px;\n    width: calc(100% - 4px);\n    line-height: 1.67;\n    border: 1px solid #ccc;\n}\n\n.leaflet-routing-geocoders button {\n    font: bold 18px 'Lucida Console', Monaco, monospace;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    margin: 0;\n    margin-right: 3px;\n    float: right;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.leaflet-routing-add-waypoint:after {\n    content: '+';\n}\n\n.leaflet-routing-reverse-waypoints:after {\n    font-weight: normal;\n    content: '\\21c5';\n}\n\n.leaflet-routing-geocoders button:hover {\n    background-color: #eee;\n}\n\n.leaflet-routing-geocoders input,.leaflet-routing-remove-waypoint,.leaflet-routing-geocoder {\n    position: relative;\n}\n\n.leaflet-routing-geocoder-result {\n    font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n    position: absolute;\n    max-height: 0;\n    overflow: hidden;\n    transition: all 0.5s ease;\n    z-index: 1000; /* Arbitrary, but try to be above \"most\" things. */\n}\n\n.leaflet-routing-geocoder-result table {\n    width: 100%;\n    border: 1px solid #ccc;\n    border-radius: 0 0 4px 4px;\n    background-color: white;\n    cursor: pointer;\n}\n\n.leaflet-routing-geocoder-result-open {\n    max-height: 800px;\n}\n\n.leaflet-routing-geocoder-selected, .leaflet-routing-geocoder-result tr:hover {\n    background-color: #eee;\n}\n\n.leaflet-routing-geocoder-no-results {\n    font-style: italic;\n    color: #888;\n}\n\n.leaflet-routing-remove-waypoint {\n    background-color: transparent;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n.leaflet-routing-remove-waypoint:after {\n    position: absolute;\n    display: block;\n    width: 15px;\n    height: 1px;\n    z-index: 1;\n    right: 1px;\n    top: 4px;\n    bottom: 0;\n    margin: auto;\n    padding: 2px;\n    font-size: 18px;\n    font-weight: bold;\n    content: \"\\00d7\";\n    text-align: center;\n    cursor: pointer;\n    color: #ccc;\n    background: white;\n    padding-bottom: 16px;\n    margin-top: -16px;\n    padding-right: 4px;\n    line-height: 1;\n}\n\n.leaflet-routing-remove-waypoint:hover {\n    color: black;\n}\n\n.leaflet-routing-instruction-distance {\n    width: 48px;\n}\n\n.leaflet-routing-collapse-btn {\n    position: absolute;\n    top: 0;\n    right: 6px;\n    font-size: 24px;\n    color: #ccc;\n    font-weight: bold;\n}\n\n.leaflet-routing-collapse-btn:after {\n    content: '\\00d7';\n}\n\n.leaflet-routing-container-hide .leaflet-routing-collapse-btn {\n    position: relative;\n    left: 4px;\n    top: 4px;\n    display: block;\n    width: 26px;\n    height: 23px;\n    background-image: url('routing-icon.png');\n}\n\n.leaflet-routing-container-hide .leaflet-routing-collapse-btn:after {\n    content: none;\n}\n\n.leaflet-top .leaflet-routing-container.leaflet-routing-container-hide {\n    margin-top: 10px !important;\n}\n.leaflet-right .leaflet-routing-container.leaflet-routing-container-hide {\n    margin-right: 10px !important;\n}\n.leaflet-bottom .leaflet-routing-container.leaflet-routing-container-hide {\n    margin-bottom: 10px !important;\n}\n.leaflet-left .leaflet-routing-container.leaflet-routing-container-hide {\n    margin-left: 10px !important;\n}\n\n@media only screen and (max-width: 640px) {\n    .leaflet-routing-container {\n        margin: 0 !important;\n        padding: 0 !important;\n        width: 100%;\n        height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
